<template>
  <v-dialog
    v-if="currentUser.permissions.add_to_collections === true"
    max-width="600"
    v-model="collectiondialog"
    class="image-popup"
  >
    <template #activator="{ on }">
      <v-btn
        right
        color="primary"
        class="mr-2"
        v-on="on"
        :disabled="itemsCount <= 0"
      >
        Add {{ itemsCount }}
        <span class="d-none d-md-flex"> to collection</span>
        <v-icon right class="material-icons"> add_photo_alternate </v-icon>
      </v-btn>
    </template>
    <v-btn
      color="primary"
      @click="collectiondialog = false"
      icon
      class="popup-close"
    >
      <v-icon>mdi-close-circle-outline</v-icon>
    </v-btn>
    <v-card>
      <div class="diaog-inner pa-10">
        <v-card-title>Add to collection</v-card-title>

        <v-card-text>
          <v-form>
            <v-tabs v-model="tabChoice" class="mb-4">
              <v-tab href="#addTo"> Add to </v-tab>
              <v-tab href="#new"> Create new collection </v-tab>
            </v-tabs>
            <v-tabs-items v-model="tabChoice">
              <v-tab-item id="addTo">
                <v-autocomplete
                  v-model="collection"
                  :loading="isLoading"
                  :search-input.sync="search"
                  :items="collections"
                  item-text="name"
                  item-value="id"
                  label="Add to existing collection"
                  filled
                  dense
                  solo
                  flat
                  outlined
                ></v-autocomplete>
              </v-tab-item>
              <v-tab-item id="new">
                <v-text-field
                  v-if="currentUser.permissions.create_collections === true"
                  label="New collection name"
                  v-model="newCollectionName"
                >
                  <v-icon right class="material-icons">
                    add_photo_alternate
                  </v-icon>
                </v-text-field>
              </v-tab-item>
            </v-tabs-items>
            <v-btn :disabled="collectionTaskLoading == true" @click="doCollection" color="primary" class="mt-2"
              >Save</v-btn
            >
            <v-progress-circular
              v-if="collectionTaskLoading == true"
              :size="28"
              right
              indeterminate
              color="primary"
            ></v-progress-circular>
          </v-form>
        </v-card-text>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import store from "@/store/";
import {
  COLLECTIONS_RESET_STATE,
  FETCH_EXPCLIENT_COLLECTIONS,
  COLLECTION_CREATE,
  SELECTED_RESET,
} from "@/store/actions.type";
import { CollectionsService } from "@/common/api.service";
import ApiService from "@/common/api.service";
import toast from "@/services/toast";

export default {
  name: "CollectionDialog",
  data: () => ({
    userCanAdd: false,
    collectiondialog: false,
    collection: null,
    newCollectionName: "",
    response: {},
    isLoading: false,
    search: null,
    collectionTaskLoading: false,

    tabChoice: "addTo",

    lastSearch: "",
  }),
  computed: {
    msg() {
      if (typeof this.response.data !== "undefined") {
        if (typeof this.response.data.message !== "undefined") {
          return this.response.data.message;
        }
        if (typeof this.response.data !== "undefined") {
          return this.response;
        }
      }
      return "";
    },
    itemsCount() {
      // Number of selected images.
      return this.selectedImages.length;
    },
    collectionList() {
      if (!this.expClientList) return [];
      return this.expClientList;
    },
    photoIds() {
      return this.selectedImages.map((val, index, arr) => {
        return val.id;
      });
    },
    ...mapGetters([
      "selectedImages",
      "collections",
      "activeExpClient",
      "currentUser",
    ]),
  },
  watch: {
    collectiondialog() {
      this.newCollectionName = "";
    },
    search(val) {
      if (val !== this.lastSearch) {
        store.dispatch(COLLECTIONS_RESET_STATE);
        // Items have already been loaded
        //if (this.items.length > 0) return
        this.isLoading = true;
        store
          .dispatch(FETCH_EXPCLIENT_COLLECTIONS, {
            client_id: this.activeExpClient.id,
            search: val,
          })
          .finally(() => {
            this.isLoading = false;
            this.lastSearch = val;
          });
      }
    },
    activeExpClient(client) {
      // If loading from the url the ExpClient is
      // set and can be missed during the mount.
      this.initiateCollectionsList();
    },
  },
  methods: {
    doCollection() {
      if (this.tabChoice == "addTo") {
        this.addToCollection();
      }
      if (this.tabChoice == "new") {
        this.newCollection();
      }
    },

    async newCollection() {
      // var self = this;
      var msg = "";
      this.collectionTaskLoading = true;
      CollectionsService.create({
        name: this.newCollectionName,
        client_id: this.activeExpClient.id,
        client_can_view: true,
        short_description: "Hold",
      }).then((resp) => {
        toast.success(resp.data.message);
        let collectionId = resp.data.collection_id;

        return ApiService.post("collection-photos", {
          client_id: this.activeExpClient.id,
          collection_id: collectionId,
          photo_ids: this.photoIds,
        })
          .then(() => {
            this.collectiondialog = false;
            toast.success(resp.data.message);
            store.dispatch(COLLECTIONS_RESET_STATE);
            store.dispatch(SELECTED_RESET);
            this.initiateCollectionsList();
            this.collectionTaskLoading = false;
          })
          .catch((err) => {
            this.collectiondialog = false;
            console.log(err);
          });
      });
    },
    async addToCollection() {
      this.collectionTaskLoading = true;
      return ApiService.post("collection-photos", {
        client_id: this.activeExpClient.id,
        collection_id: this.collection,
        photo_ids: this.photoIds,
      })
        .then((resp) => {
          console.log(resp);
          toast.success(resp.data.message);
          this.collectiondialog = false;
          store.dispatch(COLLECTIONS_RESET_STATE);
          store.dispatch(SELECTED_RESET);
          this.collectionTaskLoading = false;
        })
        .catch((err) => {
          this.collectionTaskLoading = false;
          this.collectiondialog = false;
          console.log(err);
        });
    },
    initiateCollectionsList() {
      if (this.activeExpClient) {
        if (typeof this.activeExpClient.id !== undefined) {
          store.dispatch(COLLECTIONS_RESET_STATE);
          store.dispatch(FETCH_EXPCLIENT_COLLECTIONS, {
            client_id: this.activeExpClient.id,
          });
        } else {
          toast.error("No client set");
        }
      }
    },
  },
  mounted() {
    this.initiateCollectionsList();
  },
  destroyed() {
    store.dispatch(SELECTED_RESET);
  },
};
</script>
